import { Card } from "antd";
import { ChartPie } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

type ApplicationSummaryProps = {
  className: string;
};

const visaEntryTypeFeeMap = new Map([
  ["OneMonthSingle", 54],
  ["OneMonthMultiple", 84],
  ["ThreeMonthSingle", 94],
  ["ThreeMonthMultiple", 104]
]);
const processingTimeFeeMap = new Map([
  ["Standard", 0],
  ["Express", 45],
  ["Urgent", 85]
]);

const visaEntryTypeMap = new Map([
  ["OneMonthSingle", "1mo - Single"],
  ["OneMonthMultiple", "1mo - Multiple"],
  ["ThreeMonthSingle", "3mo - Single"],
  ["ThreeMonthMultiple", "3mo - Multiple"]
]);
const processingTimeMap = new Map([
  ["Standard", "5-10 days"],
  ["Express", "2 days"],
  ["Urgent", "1 day"]
]);

const ApplicationSummary = ({ className }: ApplicationSummaryProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const visaType = location.state.typeVisa || "OneMonthSingle";
  const processingTime = location.state.processingTime || "Standard";
  const [totalFee, setTotalFee] = useState<number>(0);

  useEffect(() => {
    if (!visaType || !processingTime) {
      return;
    }

    const visaFee = visaEntryTypeFeeMap.get(visaType) || 0;
    const processingFee = processingTimeFeeMap.get(processingTime) || 0;

    setTotalFee(visaFee + processingFee);
  }, [visaType, processingTime]);

  return (
    <div className={`${className}`}>
      <Card
        title={
          <div className="flex items-center gap-2 text-primary-blue font-bold">
            <ChartPie size={24} className="text-orange-500" />
            {t("select_payment_option.order_summary")}
          </div>
        }
      >
        <div className="flex justify-between py-4 border-b border-dashed text-sm">
          <div>{t("home.visa_type")}:</div>
          <div className="text-primary-blue font-medium">
            {visaEntryTypeMap.get(visaType)}
          </div>
        </div>

        <div className="flex justify-between py-4 border-b border-dashed text-sm">
          <div>{t("home.processing_time")}:</div>
          <div className="text-primary-blue font-medium">
            {processingTimeMap.get(processingTime)}
          </div>
        </div>

        <div className="flex justify-between py-4 text-2xl font-bold text-primary-blue">
          <div>{t("select_payment_option.order_summary.total")}:</div>
          <div>${totalFee}</div>
        </div>
      </Card>
    </div>
  );
};

export default ApplicationSummary;
